module.exports = __webpack_public_path__ + "img/smartEnergy-hd.742a3288.jpg";